import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/faqherosectionvector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/faqsHeroBottomVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/faqsLeftMobileVector.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Faqs/FaqsSectionTwo.jsx");
